import React from "react";
import PropTypes from "prop-types";
import classes from "./articleMax.module.scss";
import { useSelector } from "react-redux";
import Item from "../item/item.js";
import Link from "../../../../UI/link/link.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ArticleMax = () => {
  const rivers = useSelector((state) => state.home.rivers);
  const river = useSelector((state) => state.home.form.rivers.value);
  const link = useSelector((state) => state.home.link);

  return river ? (
    <div className={classes.article__wrapper}>
      <article className={classes.article}>
        <div className={classes.img__section}>
          <div className={classes.img__wrapper}>
            <img className={classes.img} src={rivers[river].src} alt="river" />
            <div className={classes.linkDetail}>
              <Link
                inner={
                  <FontAwesomeIcon
                    icon={link.icon}
                    style={{ fontSize: "3em" }}
                  />
                }
                to={link.to + "?" + river}
              />
            </div>
          </div>
          <ul className={classes.list_inform}>
            <li>
              <span>Довжина: </span> 2201 км
            </li>
            <li>
              <span>Басейн: </span> 504 000 км²
            </li>
            <li>
              <span>Середньорічний стік: </span> 1670 м³/с (В гирлі)
            </li>
            <li>
              <span>Водна система: </span> Чорне море
            </li>
            <li>
              <span>Ухил річки: </span> 0,09 м/км
            </li>
            <li>
              <span>Тип річки: </span> рівнинна
            </li>
            <li>
              <span>Судноплавство країни: </span> 65%
            </li>
            <li>
              <span>Водні ресурси країни: </span> 60%
            </li>
          </ul>
        </div>
        <div className={classes.header__title}>
          <h2>Річка {rivers[river].name}</h2>
          <p>
            <div className={classes.map__img}>
              <img
                className={classes.img}
                src={rivers[river].srcMapImg}
                alt="river"
              />
            </div>
            {rivers[river].inform}
          </p>
        </div>
      </article>
    </div>
  ) : null;
};

ArticleMax.propTypes = {
  //products: PropTypes.array
};

export default ArticleMax;
